import { combineReducers } from 'redux';
import recruitsReducer from './RecruitsPage/reducer';
import smsCampaignsReducer from './RecruitsPage/SmsCampaigns/reducer';
import chatReducer from "./RecruitsPage/ChatComponent/reducer";

const initialState = {
  loading: false,
  error: '',
};

const mainReducer = (state = initialState, {
  type,
}) => {
  switch (type) {
    default:
      return state;
  }
};

const registrationFormReducer = combineReducers({
  main: mainReducer,
  list: recruitsReducer,
  smsCampaigns: smsCampaignsReducer,
  chat: chatReducer,
});

export default registrationFormReducer;
